import { render } from "./tick.svg?vue&type=template&id=3ffa72a3"
const script = {}

import exportComponent from "/Users/ashley.eastham/Fostr Dev/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__